const MODULE_NAME = 'OfflineModule';

export const DELETE_RECORD_FROM_DB = `${MODULE_NAME}/DELETE_RECORD_FROM_DB`;
export const SET_IS_OFFLINE_STATUS = `${MODULE_NAME}/SET_IS_OFFLINE_STATUS`;
